// TODO refactor all functions and dependencies to sit in this common folder outside
// of site and design system so they can be used anywhere.

// transformTags is currently duplicated in site/src/utils/transform-data-functions.js
export const transformTags = tags => {
  if (tags) {
    const filteredTags = tags.filter(tag => tag !== 'None applicable');
    const transformedTags = filteredTags.map(tag => ({
      title: tag,
    }));
    return transformedTags.length > 0 ? transformedTags : null;
  } else {
    return null;
  }
};
